import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import AlcoholTooltip from '@/components/alcohol/AlcoholTooltip';
import { WeeeIcon } from '@/components/common/Icon';
import PantryToolTip from '@/components/pantry/PantryToolTip';
import useDebounce from '@/hooks/debounce';
import { ProductType } from '@/types/product';
import { CartItemV2 } from '@/types/so';
import styles from './index.module.scss';

const PROMOTION_OFFER_LIST = 'promotion_offer_list';

export interface CartbtnProp {
  num?: number;
  subtractCount: (e: React.SyntheticEvent) => any;
  addCount: (e: React.SyntheticEvent, cb: (num: number) => void) => any;
  max?: number;
  min?: number;
  renderCartCountText?: boolean;
  className?: string;
  text?: string;
  minLimitArrowToTarget?: number;
  preSell?: boolean;
  is_pantry?: boolean;
  isAlcohol?: boolean;
  isInProductCard?: boolean;
  link?: string;
  data?: ProductType | CartItemV2;
  showTooltip?: boolean;
}
export default function Cartbtn({
  num,
  subtractCount,
  addCount,
  renderCartCountText,
  max,
  min,
  className,
  text,
  minLimitArrowToTarget,
  preSell,
  is_pantry,
  isAlcohol,
  link,
  isInProductCard = false,
  data,
  showTooltip
}: CartbtnProp) {
  const { t, lang } = useTranslation('common');
  const numQtyRef = useRef(null);
  const addBtnRef = useRef(null);
  const [maxQuntityTip, setMaxQuntityTip] = useState(false);
  const [minQuntityTip, setMinQuntityTip] = useState(false);
  const [pantryTityTip, setPantryTityTip] = useState(false);
  const [pantryTityTipInit, setPantryTityTipInit] = useState(false);
  const [alcoholTip, setAlcoholTip] = useState(false);
  const [alcoholTipInit, setAlcoholTipInit] = useState(false);
  const [isHandleAdd, setIsHandleAdd] = useState(false);
  const [innerFocus, setInnerFocus] = useState<boolean>(false);
  const [showAddBtn, setShowAddBtn] = useState<boolean>(true);
  const wrapperRef = useRef<HTMLDivElement>();
  const toolTipRef = useRef(null);

  const handleAlcoholTip = () => {
    return new Promise((resolve, reject) => {
      if (!!isAlcohol && !localStorage?.getItem('showedAlcoholTooltip')) {
        if (!alcoholTipInit && isHandleAdd) {
          if (num >= 1 && num != max && (min === 1 || num != min)) {
            resolve(true);
          } else {
            setAlcoholTip(false);
          }
        }
        if (num === 0) {
          try {
            if (!localStorage?.getItem('showedAlcoholTooltip')) {
              setAlcoholTipInit(false);
            }
          } catch (error) {}
          setAlcoholTip(false);
        }
      }
      resolve(false);
    });
  };

  const handlePantryTip = () => {
    return new Promise((resolve, reject) => {
      if (is_pantry && !localStorage?.getItem('showedPantryTooltip')) {
        if (!pantryTityTipInit && isHandleAdd) {
          if (num >= 1 && num != max && (min === 1 || num != min)) {
            resolve(true);
          } else {
            setPantryTityTip(false);
          }
        }
        if (num === 0) {
          try {
            if (!localStorage?.getItem('showedPantryTooltip')) {
              setPantryTityTipInit(false);
            }
          } catch (error) {}
          setPantryTityTip(false);
        }
      }
      resolve(false);
    });
  };

  useEffect(() => {
    async function compareTwoTip() {
      const [showAlcoholTip, showPantryTip] = await Promise.all([handleAlcoholTip(), handlePantryTip()]);

      if (showAlcoholTip) {
        setAlcoholTipInit(true);
        return;
      }
      if (showPantryTip) {
        setPantryTityTipInit(true);
        return;
      }
    }
    compareTwoTip();
  }, [num]);

  const handleAddCount = e => {
    if (preSell) {
      if (!!link) {
        window.location.href = link;
      }
      return;
    }

    if (+max !== +num) {
      addCount &&
        addCount(e, curNum => {
          setIsHandleAdd(true);
          checkMaxLimit(curNum);
          checkMinLimit(curNum);
        });
    } else {
      checkMaxLimit(max);
    }
  };

  const handleSubtractCount = e => {
    subtractCount && subtractCount(e);
  };

  const checkMaxLimit = useDebounce((curNum: number) => {
    if (+max === +curNum) {
      clearTimeout(toolTipRef.current);
      setMaxQuntityTip(true);
      toolTipRef.current = setTimeout(() => {
        setMaxQuntityTip(false);
      }, 2000);
    } else {
      setMaxQuntityTip(false);
    }
  }, 300);

  const checkMinLimit = useDebounce((curNum: number) => {
    if (+min === +curNum && min > 1 && max !== min) {
      clearTimeout(toolTipRef.current);
      setMinQuntityTip(true);
      toolTipRef.current = setTimeout(() => {
        setMinQuntityTip(false);
      }, 2000);
    } else {
      setMinQuntityTip(false);
    }
  }, 300);

  useEffect(() => {
    return () => {
      clearTimeout(toolTipRef.current);
    };
  }, []);

  useEffect(() => {
    if (alcoholTipInit) {
      setAlcoholTip(true);
      localStorage?.setItem('showedAlcoholTooltip', '1');
      const timer = setTimeout(() => {
        setAlcoholTip(false);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [alcoholTipInit]);

  useEffect(() => {
    if (pantryTityTipInit) {
      setPantryTityTip(true);
      setAlcoholTip(false);
      localStorage?.setItem('showedPantryTooltip', '1');
      const timer = setTimeout(() => {
        setPantryTityTip(false);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [pantryTityTipInit]);

  /**inner模式下点击外部收起加购按钮 */
  useEffect(() => {
    const handleClickOutside = e => {
      if (wrapperRef && !wrapperRef.current?.contains(e.target)) {
        setInnerFocus(false);
      }
    };
    if (isInProductCard) {
      document.addEventListener('click', handleClickOutside, true);
      document.addEventListener('scroll', handleClickOutside, true);
    }
    return () => {
      if (isInProductCard) {
        document.removeEventListener('click', handleClickOutside, true);
        document.removeEventListener('scroll', handleClickOutside, true);
      }
    };
  }, []);

  const btnBoxElement = (
    <div className={classNames(styles.btnBox)} data-role="addButtonBox">
      <div
        data-testid="btn-atc-minus"
        onClick={handleSubtractCount}
        className={classNames(styles.cart, styles.cartLeft)}
        data-role="minusButton">
        {+num === +min ? (
          <WeeeIcon type="iconDelete" className={styles.trashIcon} data-role="addButtonTrasbin" role="button" />
        ) : (
          <WeeeIcon type="iconcolor-minus" className={styles.plusIcon} data-role="addButtonMinusIcon" role="button" />
        )}
      </div>

      {minQuntityTip && (
        <div
          className={classNames(styles.tooltipBox, {
            [styles.inProductCard]: isInProductCard
          })}
          data-role="tooltipBox">
          <span className={styles.tooltipText} data-role="tooltipText">
            {t('min_order_quantity_limit', { count: min })}
          </span>
        </div>
      )}
      <p
        className={classNames({
          [styles.labelCount]: isInProductCard
        })}
        ref={numQtyRef}
        data-role="current-qty">
        {renderCartCountText ? t('add_cart_count', { count: num }) : num}
      </p>

      {maxQuntityTip && (
        <div
          className={classNames(styles.tooltipBox, {
            [styles.inProductCard]: isInProductCard
          })}
          data-role="tooltipBox">
          <span className={classNames(styles.tooltipText)} data-role="tooltipText">
            {t('max_order_quantity_limit', { count: max })}
          </span>
        </div>
      )}
      <div
        ref={addBtnRef}
        data-testid="btn-atc-plus"
        className={classNames(styles.cart, { [styles.disable]: +max === +num })}
        onClick={handleAddCount}
        data-role={`addButton${+max === +num ? ' addButtonDisabled' : ''}`}>
        <WeeeIcon type="iconcolor-plus" className={styles.plusIcon} data-role="addButtonPlusIcon" role="button" />
      </div>
    </div>
  );

  const renderBtnBox = () => {
    //isInProductCard为true 会展示加购按钮动画, 其他的则不展示动画
    if (isInProductCard) {
      return (
        <CSSTransition
          in={+num > 0 && innerFocus}
          timeout={260}
          unmountOnExit
          onEnter={() => {
            setShowAddBtn(false);
          }}
          onExited={() => {
            setShowAddBtn(true);
          }}
          classNames={{
            enter: styles['fold-enter'],
            enterActive: styles['fold-enter-active'],
            exit: styles['fold-exit'],
            exitActive: styles['fold-exit-active']
          }}>
          {btnBoxElement}
        </CSSTransition>
      );
    } else {
      return +num > 0 ? btnBoxElement : null;
    }
  };

  return (
    <div
      className={classNames(styles.btnContainer, className)}
      ref={wrapperRef}
      onClick={() => {
        setInnerFocus(true);
      }}>
      {+num === 0 &&
        showAddBtn &&
        (text ? (
          <div data-role="addCartText" onClick={handleAddCount}>
            {text}
          </div>
        ) : (
          <div
            data-testid="btn-atc-plus"
            onClick={handleAddCount}
            className={classNames(styles.cart, styles.cartAdd, {
              [styles.disable]: preSell
            })}
            data-role="addButton">
            {text || (
              <WeeeIcon type="iconcolor-plus" className={styles.plusIcon} data-role="addButtonPlusIcon" role="button" />
            )}
          </div>
        ))}
      {renderBtnBox()}

      {+num > 0 && isInProductCard && showAddBtn && (
        <div
          ref={addBtnRef}
          data-testid="btn-atc-plus"
          className={classNames(styles.cart, { [styles.disable]: +max === +num })}
          data-role={`addButton${+max === +num ? ' addButtonDisabled' : ''}`}>
          <span className={styles.amount}>{num}</span>
        </div>
      )}
      <PantryToolTip visible={true} targetEl={addBtnRef} />
      <AlcoholTooltip visible={alcoholTip} targetEl={addBtnRef} />
    </div>
  );
}
